export interface Mall {
  /** 商城名称 */
  mall_name: string
  /** 商城应用名称 */
  mall_app_name: string
  /** 商城 ID（即商城管理的AppID） */
  mall_id: string
  /** 商城资源位标识 ID（用以判断资源位数据是否属于当前商城） */
  mall_resource_flag_id: string
  /** 商城首页搜索场景 ID */
  mall_home_search_scene_id: string
  /** 店铺主页搜索场景 ID */
  mart_home_search_scene_id: string
  /** 分类搜索场景 ID */
  category_search_scene_id: string
  /** 支付结果页推荐资源位 ID */
  pay_result_recommend_resource_id: string
  /** 用于请求头签名 */
  app_key: string
  /** 用于请求头签名 */
  app_secret: string
  /** 请求数据加密 RSA 公钥（即商城管理的前端RSA私钥） */
  request_rsa_public_key: string
  /** 返回数据解密 RSA 公钥（即商城管理的RSA公钥） */
  response_rsa_public_key: string
}

const malls: Mall[] =
  process.env.VUE_APP_RUN_ENV !== 'production'
    ? // 开发、测试环境
      [
        {
          mall_name: '省内版商城',
          mall_app_name: 'duoduo-mall',
          mall_id: '8aaa8f8378d022aa0178d989ebe2000c',
          mall_resource_flag_id: '8aaa863878cae5670178d95ebd88003a',
          mall_home_search_scene_id: '55f9be7e73c04949bfa7a0c850d33924',
          mart_home_search_scene_id: '55f9be7e73c04949bfa7a0c850d33924',
          category_search_scene_id: '55f9be7e73c04949bfa7a0c850d33924',
          pay_result_recommend_resource_id: '8aaa88db79c085b10179c155ce730011',
          app_key: '734FF7F5AF524A839722A68441DE092F',
          app_secret: '92A22A84F6ED468399E28DF85B7F862D',
          request_rsa_public_key:
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgV6r8payps7wGK2RBcjnfUrELQYcnrNbkdKrCvjnSz1omdqcSoheDPItOhTBAC0Foq/5isI9bQhsIJanLuS7YQE6/vDOKg/U6vD6oJGFXp/gXh4cHQLLZqjoFjcDxLSmpSB6G13I9xGoMkdEsDLpGyFYqS7SUM5RJdFnVsCO445tIuh7GNvbSw7OzB+bjRLa+jy9Y6wTpK+WB1vcmwpKA+5I5V7/ISkrS0gXAjy+58UPkxCwD9SkDznQUoi6taeOHDurYWq8Lj+IwEhsk7rLlIoPX5t7VVwrbVwTiAGVQup91kGr/15qb0hSoy/OLQyZkQ7e0WGB0jPCMeBvUzdd2QIDAQAB',
          response_rsa_public_key:
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAj2QyYORbyjAJZRkiUIhIB2+q4tFKN4RUUVsjeuGSBGpPfe+eJcbQtFyyCngqL3N+8ZxHBdRsclJ3OlA7dsZqfDmQry2RZ5soOtnfj3VMkcVT1c0OGU0XyGSZOOtP5Q5eKVQRmfzgr9d05TGEk6QyQCGEJFYmr9zB1ljHI7LTDIy8d212vvAvG8/sn4D+2cKfgen7rYhsus0+nx1ZX3e72V6qz9JIblYu3cEs3GNfphFuIC7v0BoFhSaE0janCRDCXPHhfFpVaDIN1SaRrm42S2yj2aYkav+IpKnVNDeBVrfoQ4VpnAQMI1ximY7lLbLxM2eA7iB02Z7exAbDPPnbZQIDAQAB',
        },
        {
          mall_name: '全国版商城',
          mall_app_name: 'china-mall',
          mall_id: '8aaa8f8378d022aa0178d0e424da0009',
          mall_resource_flag_id: '',
          mall_home_search_scene_id: '696c48c703634113a8dd94419109db58',
          mart_home_search_scene_id: '696c48c703634113a8dd94419109db58',
          category_search_scene_id: '443d30e828c949f1b55945d74764d677',
          pay_result_recommend_resource_id: '',
          app_key: 'AEC5A82DA6E14E6693B304919C3266C1',
          app_secret: '53BD7D50365B493094F77A8F3CB88536',
          request_rsa_public_key:
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiTQJoShd2jbm1NH4AcXiPoV4tGuK9T31 WVisaDtKkTiY6LxqUvKUFecoYL7h8KL2ke+4owmvp1F2j+jzdrIhesYIHwvtlvUND8o0HyJme+2D Okwf4TRYoMzUz2+peybGdOSrRvb5gXrNBo3DrOxUryRJzOgz2GmqUcM1WGb2Fat2wZXL/UqGrpBB KtNxHBONYJHIv0ThxagZCxunTEPR0kw/BclV5MVLpss9rlL7KyZ8ZT0bGW37PF2k/ZFpnPrWpdmj iTDNaaQqM/3FFNDeqzu1ZWD5OKGadUFM3l4/OLL5jQbmv4DO8rpWqCcelrpIoP6U/ouS5SNkg64C Ld0O0QIDAQAB',
          response_rsa_public_key:
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkR2IxVmFlkafAEcDs4I0U7m3rMuljBvY 1gJ7gIM1b36/oVipoPJmyilzI8exrKYsTeTIudIVeNrTb5Q4BBOM8eQN1eHWlzttpXuJt6jArCdE ZaoueNPOEjgsxMT6GCYjkp4kKz9ZpxGqbZPBHhKVysaUEPZSTXhTAV84q0GHo4k8GrbSiobpmELa Ly6eHwjEof2pg5KNaUGWh765OKYr3klV/H69pZorBfuoiKLRyB1Z1cfhvbyC72BDwOImp0EmMKnd 6yOJEprhI4MRxpjgSC4NTCy2HLkdv5TlLnDvxtw13ExKbUG6FaDSzRpA/aOZSXNG25QPUCbyxcjJ AYMfywIDAQAB',
        },
      ]
    : // 生产环境
      [
        {
          mall_name: '省内版商城',
          mall_app_name: 'duoduo-mall',
          mall_id: '8aaaaf7c78f92ac001790c85ef6e0000',
          mall_resource_flag_id: '8aaa9fe978f4360c01790bf2efdc005d',
          mall_home_search_scene_id: '572360f4de8f4414b2cb65f3b92d72b8',
          mart_home_search_scene_id: '572360f4de8f4414b2cb65f3b92d72b8',
          category_search_scene_id: '572360f4de8f4414b2cb65f3b92d72b8',
          pay_result_recommend_resource_id: '8aaa88db79c085b10179c155ce730011',
          app_key: '734FF7F5AF524A839722A68441DE092F',
          app_secret: '92A22A84F6ED468399E28DF85B7F862D',
          request_rsa_public_key:
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgV6r8payps7wGK2RBcjnfUrELQYcnrNbkdKrCvjnSz1omdqcSoheDPItOhTBAC0Foq/5isI9bQhsIJanLuS7YQE6/vDOKg/U6vD6oJGFXp/gXh4cHQLLZqjoFjcDxLSmpSB6G13I9xGoMkdEsDLpGyFYqS7SUM5RJdFnVsCO445tIuh7GNvbSw7OzB+bjRLa+jy9Y6wTpK+WB1vcmwpKA+5I5V7/ISkrS0gXAjy+58UPkxCwD9SkDznQUoi6taeOHDurYWq8Lj+IwEhsk7rLlIoPX5t7VVwrbVwTiAGVQup91kGr/15qb0hSoy/OLQyZkQ7e0WGB0jPCMeBvUzdd2QIDAQAB',
          response_rsa_public_key:
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAj2QyYORbyjAJZRkiUIhIB2+q4tFKN4RUUVsjeuGSBGpPfe+eJcbQtFyyCngqL3N+8ZxHBdRsclJ3OlA7dsZqfDmQry2RZ5soOtnfj3VMkcVT1c0OGU0XyGSZOOtP5Q5eKVQRmfzgr9d05TGEk6QyQCGEJFYmr9zB1ljHI7LTDIy8d212vvAvG8/sn4D+2cKfgen7rYhsus0+nx1ZX3e72V6qz9JIblYu3cEs3GNfphFuIC7v0BoFhSaE0janCRDCXPHhfFpVaDIN1SaRrm42S2yj2aYkav+IpKnVNDeBVrfoQ4VpnAQMI1ximY7lLbLxM2eA7iB02Z7exAbDPPnbZQIDAQAB',
        },
        {
          mall_name: '全国版商城',
          mall_app_name: 'china-mall',
          mall_id: '8aaa8f8378d022aa0178d0e424da0009',
          mall_resource_flag_id: '',
          mall_home_search_scene_id: '696c48c703634113a8dd94419109db58',
          mart_home_search_scene_id: '696c48c703634113a8dd94419109db58',
          category_search_scene_id: '443d30e828c949f1b55945d74764d677',
          pay_result_recommend_resource_id: '',
          app_key: 'AEC5A82DA6E14E6693B304919C3266C1',
          app_secret: '53BD7D50365B493094F77A8F3CB88536',
          request_rsa_public_key:
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiTQJoShd2jbm1NH4AcXiPoV4tGuK9T31 WVisaDtKkTiY6LxqUvKUFecoYL7h8KL2ke+4owmvp1F2j+jzdrIhesYIHwvtlvUND8o0HyJme+2D Okwf4TRYoMzUz2+peybGdOSrRvb5gXrNBo3DrOxUryRJzOgz2GmqUcM1WGb2Fat2wZXL/UqGrpBB KtNxHBONYJHIv0ThxagZCxunTEPR0kw/BclV5MVLpss9rlL7KyZ8ZT0bGW37PF2k/ZFpnPrWpdmj iTDNaaQqM/3FFNDeqzu1ZWD5OKGadUFM3l4/OLL5jQbmv4DO8rpWqCcelrpIoP6U/ouS5SNkg64C Ld0O0QIDAQAB',
          response_rsa_public_key:
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkR2IxVmFlkafAEcDs4I0U7m3rMuljBvY 1gJ7gIM1b36/oVipoPJmyilzI8exrKYsTeTIudIVeNrTb5Q4BBOM8eQN1eHWlzttpXuJt6jArCdE ZaoueNPOEjgsxMT6GCYjkp4kKz9ZpxGqbZPBHhKVysaUEPZSTXhTAV84q0GHo4k8GrbSiobpmELa Ly6eHwjEof2pg5KNaUGWh765OKYr3klV/H69pZorBfuoiKLRyB1Z1cfhvbyC72BDwOImp0EmMKnd 6yOJEprhI4MRxpjgSC4NTCy2HLkdv5TlLnDvxtw13ExKbUG6FaDSzRpA/aOZSXNG25QPUCbyxcjJ AYMfywIDAQAB',
        },
      ]

const currentMallId = location.href.match(
  /[?&](?:mallId|mall_id|martId|mart_id)=(.*?)([#&\b]|$)/,
)?.[1]

export const currentMall =
  (currentMallId && malls.find(mall => mall.mall_id === currentMallId)) ||
  malls[0]

export const currentApiMall = malls[0]
